export default __webpack_public_path__ + "ac-icon.png";